<template>
  <layout
    :titlePage="getNameRouter() + ' - Editar'"
    :route="{ name: 'convites-layouts' }"
  >
    <submenuBack v-if="hasToShowNewMenu" />
    <div class="columns columns--full is-vcentered save-the-date-layout">
      <div class="column">
        <div class="container has-text-centered">
          <p class="save-the-date-layout__title">
            <b>Personalize com os dados do seu casamento</b>
          </p>
          <CanvasStd
            v-if="this.$router.currentRoute.params.tipo === 'save-the-date'"
          />
          <CanvasCommunication
            v-if="this.$router.currentRoute.params.tipo === 'comunicado'"
          />
          <CanvasInvite
            v-if="this.$router.currentRoute.params.tipo === 'oficial'"
          />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import submenuBack from '@/layouts/parts/SubmenuBack.vue'
import CanvasStd from '@/components/Invites/CanvasStd.vue'
import CanvasInvite from '@/components/Invites/CanvasInvite.vue'
import CanvasCommunication from '@/components/Invites/CanvasCommunication.vue'

import loadingViewMixin from '@/mixins/loadingViewMixin'

export default {
  mixins: [loadingViewMixin],
  components: {
    layout,
    submenuBack,
    CanvasStd,
    CanvasInvite,
    CanvasCommunication,
  },

  created() {
    this.loading = true
  },

  data() {
    return {
      weddingInfos: '',
    }
  },

  computed: {
    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },
  },

  mounted() {
    this.loading = false
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
  },

  methods: {
    getNameRouter() {
      const router = this.$router.currentRoute.params.tipo

      if (router === 'save-the-date') {
        return 'Save the date'
      } else if (router === 'oficial') {
        return 'Convite oficial'
      } else {
        return router.charAt(0).toUpperCase() + router.slice(1)
      }
    },
  },
}
</script>

<style lang="scss">
.layout::before {
  content: none;
}
.save-the-date-layout {
  padding-top: 50px;
  padding-bottom: 40px;

  &__description {
    margin-bottom: 10px;
  }

  &__dicas {
    li {
      list-style-type: disc;
      list-style-position: inside;
      text-align: left;
      margin: 10px 10px 15px 10px;
    }
  }
}
.w-10 {
  width: 100%;
}

.canvas-border {
  border: solid 1px $gray-4;
}
</style>
